import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ReminderSystemFlowchart from './ReminderSystemFlowchart';
import '../BasicReminder.css';
import '../App.css';
import { LoginIcon, LogoutIcon, UserNameIcon, 
    TextMessageIcon, CalendarIcon, 
    DashboardIcon, SweatIcon } from '../icons';

import {  useAuth} from '../auth';

export const GetStartedReminderButton = () => {
  const navigate = useNavigate();

  const { user } = useAuth();
  if (user && user.role.includes('trainer')) {
	return null;
  }

  return (<button
        onClick={() => navigate('/tools/reminders/step1')}
        style={{
          padding: '1rem 2rem',
          margin: '2rem auto',
          display: 'block',
          fontSize: '1.2rem',
          background: 'linear-gradient(90deg, #42a5f5, #66bb6a)',
          color: 'white',
          border: 'none',
          borderRadius: 8,
          fontSize: '2rem',
          cursor: 'pointer',
          boxShadow: '0 15px 20px rgba(0,0,0,0.2)',
          animation: 'getting-started-pulse 1s infinite',
          transition: 'transform 0.2s, box-shadow 0.2s',
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(2)';
          e.target.style.boxShadow = '0 12px 24px rgba(0,0,0,0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
        }}
      >
        🚀 Sign Up as a New Trainer!
      </button>);
}

const RemindersInfo = () => {
  return null; 

  // const navigate = useNavigate();
  // const { user } = useAuth();
  // const [isCollapsed, setIsCollapsed] = useState(true);

  // return (
	// <>
  //     {isCollapsed ? (
  //       <button
  //       className="ptc-button"
  //         onClick={() => setIsCollapsed(false)}
  //           style={{
  //             padding: '0.3rem 0.6rem',
  //             fontSize: '0.8rem',
  //             cursor: 'pointer',
  //             border: 'none',
  //             borderRadius: '4px',
  //             margin: '1rem auto',
  //             marginTop: '0rem'
  //           }}
  //         >
  //           What is SweatText?
  //         </button>
  //     ) : (
	// 	<div
	// 	  style={{
	// 		border: '5px solid #aaa',
	// 		borderRadius: '8px',
	// 		padding: isCollapsed ? '0.5rem' : '2rem',
  //     paddingTop: 0,
	// 		margin: '1rem auto',
	// 		boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
	// 		textAlign: 'center',
	// 		transition: 'all 0.3s ease',
	// 	  }}
	// 	>
  //         <button
  //           onClick={() => setIsCollapsed(true)}
  //           style={{
  //             marginBottom: '1rem',
	// 		        marginTop: 0,
  //             padding: '0.5rem 1rem',
  //             paddingTop: 0,
  //             fontSize: '1rem',
  //             cursor: 'pointer',
  //             border: 'none',
  //             borderRadius: '0px',
  //             background: '#aaa',
  //             color: 'black',
  //           }}
  //         >
  //           Collapse 'What is SweatText?'
  //         </button>
  //         <p>
  //           Set up a schedule to send SMS text messages to your clients at designated times to remind them of your workout sessions!
  //         </p>
  //         <p>
  //           This tool helps trainers and coaches send automated SMS reminders to their clients, ensuring they never miss a session.
  //         </p>
  //         {/* <GetStartedReminderButton /> */}
  //         <ReminderSystemFlowchart />
	// 	</div>
  //     )}


	//   </>
  // );
};


export default RemindersInfo;